export default __webpack_public_path__ + "static/media/circle-cancel-icon.78f74036.svg";